/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementDTO } from './EntitlementDTO';
import {
    EntitlementDTOFromJSON,
    EntitlementDTOFromJSONTyped,
    EntitlementDTOToJSON,
    EntitlementDTOToJSONTyped,
} from './EntitlementDTO';

/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    firstName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    activeWeek?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    revenueCatId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserDTO
     */
    created?: Date;
    /**
     * 
     * @type {EntitlementDTO}
     * @memberof UserDTO
     */
    entitlement?: EntitlementDTO;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    mixpanelId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDTO
     */
    onboardingCompleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    voiceTypeId?: number | null;
}

/**
 * Check if a given object implements the UserDTO interface.
 */
export function instanceOfUserDTO(value: object): value is UserDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UserDTOFromJSON(json: any): UserDTO {
    return UserDTOFromJSONTyped(json, false);
}

export function UserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'activeWeek': json['activeWeek'] == null ? undefined : json['activeWeek'],
        'revenueCatId': json['revenueCatId'] == null ? undefined : json['revenueCatId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'entitlement': json['entitlement'] == null ? undefined : EntitlementDTOFromJSON(json['entitlement']),
        'mixpanelId': json['mixpanelId'] == null ? undefined : json['mixpanelId'],
        'onboardingCompleted': json['onboardingCompleted'] == null ? undefined : json['onboardingCompleted'],
        'voiceTypeId': json['voiceTypeId'] == null ? undefined : json['voiceTypeId'],
    };
}

export function UserDTOToJSON(json: any): UserDTO {
    return UserDTOToJSONTyped(json, false);
}

export function UserDTOToJSONTyped(value?: UserDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'activeWeek': value['activeWeek'],
        'revenueCatId': value['revenueCatId'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'entitlement': EntitlementDTOToJSON(value['entitlement']),
        'mixpanelId': value['mixpanelId'],
        'onboardingCompleted': value['onboardingCompleted'],
        'voiceTypeId': value['voiceTypeId'],
    };
}

